export default function ElectricalServicesElPaso() {
  const services = [
    {
      image: 'https://public.readdy.ai/ai/img_res/83022f52952ed2700205de8996f1f8ac.jpg',
      title: 'Panel & Service Upgrades',
      features: ['200 Amp Service', 'Code Compliant', 'Permit Included', 'Same Day Service'],
      description: 'Upgrade outdated electrical panels to meet modern power demands and improve home safety with professional installation'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=professional%20electrician%20rewiring%20residential%20home%20interior%20with%20new%20copper%20wiring%20and%20electrical%20boxes%20showing%20careful%20installation%20work%20and%20attention%20to%20safety%20standards%20in%20construction%20setting&width=600&height=400&seq=electrical-service-2&orientation=landscape',
      title: 'Whole Home Rewiring',
      features: ['Complete Rewiring', 'Updated Code', 'Minimal Disruption', 'Warranty Included'],
      description: 'Complete home rewiring services for older homes to eliminate hazards and support modern electrical needs'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=skilled%20electrician%20installing%20elegant%20recessed%20lighting%20fixtures%20in%20modern%20home%20ceiling%20with%20precision%20tools%20and%20professional%20technique%20in%20bright%20residential%20interior%20setting&width=600&height=400&seq=electrical-service-3&orientation=landscape',
      title: 'Lighting Design & Installation',
      features: ['Custom Design', 'LED Upgrades', 'Smart Controls', 'Energy Efficient'],
      description: 'Professional lighting solutions including recessed lighting, chandeliers, outdoor lighting, and smart home integration'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=electrician%20installing%20electric%20vehicle%20charging%20station%20in%20residential%20garage%20with%20modern%20EV%20charger%20equipment%20and%20professional%20wiring%20installation%20in%20clean%20organized%20setting&width=600&height=400&seq=electrical-service-4&orientation=landscape',
      title: 'EV Charger Installation',
      features: ['Level 2 Chargers', 'Fast Charging', 'Smart Features', 'Rebate Assistance'],
      description: 'Expert installation of electric vehicle charging stations for convenient home charging with optimal power delivery'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=professional%20electrician%20installing%20backup%20generator%20system%20for%20residential%20home%20with%20transfer%20switch%20and%20electrical%20connections%20showing%20emergency%20power%20solution%20in%20outdoor%20setting&width=600&height=400&seq=electrical-service-5&orientation=landscape',
      title: 'Generator Installation',
      features: ['Automatic Transfer', 'Whole House', 'Natural Gas/Propane', 'Maintenance Plans'],
      description: 'Standby generator installation and maintenance to keep your home powered during outages and emergencies'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=electrician%20installing%20smart%20home%20automation%20system%20with%20touchscreen%20control%20panel%20and%20wireless%20devices%20in%20modern%20residential%20interior%20showing%20advanced%20technology%20integration&width=600&height=400&seq=electrical-service-6&orientation=landscape',
      title: 'Smart Home Wiring',
      features: ['Home Automation', 'Voice Control', 'App Integration', 'Future Ready'],
      description: 'Smart home electrical infrastructure for automated lighting, climate control, security, and entertainment systems'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Popular Electrical Services in El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore the most requested electrical services from licensed contractors serving El Paso homes and businesses
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow"
            >
              <div className="w-full h-64">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {service.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {service.features.map((feature, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1 bg-orange-50 text-orange-700 rounded-full text-sm font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
